// extracted by mini-css-extract-plugin
export default {"section":"CreditScoreSection_section__zOXQt","sectionLabel":"CreditScoreSection_sectionLabel__uVSeO","skeletonLoadingAnimation":"CreditScoreSection_skeletonLoadingAnimation__HxGDH"};